module.exports = __webpack_public_path__ + "static/media/search-oro.ca39ceee.svg";